// views/RegisterPage.js
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useModal } from 'context';
import SignupForm from 'modals/SignupForm';
import HomePage from 'views/HomePage';
import PropTypes from 'prop-types';
import { getToken } from 'helpers/tokenHelpers';
import { useTranslation } from 'react-i18next';

const RegisterPage = ({ userType = 'seeker' }) => {
  const navigate = useNavigate();
  const { openModal, closeModal } = useModal();
  const [searchParams] = useSearchParams();
  const {t} = useTranslation("global");
  
  // ============================================================
  // DETECT BOOKING FLOW FROM URL PARAM OR SESSION STORAGE
  // ============================================================
  const isBookingFlowFromUrl = searchParams.get('booking_flow') === 'true';
  const hasPendingBookingAfterOAuth = sessionStorage.getItem('has_pending_booking_after_oauth') === 'true';
  const justRegisteredForBooking = sessionStorage.getItem('just_registered_for_booking') === 'true';
  const bookingSpaceId = sessionStorage.getItem('booking_space_id');
  const pendingData = sessionStorage.getItem('pending_booking_data');
  
  const isBookingFlow = isBookingFlowFromUrl || hasPendingBookingAfterOAuth || justRegisteredForBooking;
  
  let spaceId = bookingSpaceId;
  if (!spaceId && pendingData) {
    try {
      const data = JSON.parse(pendingData);
      spaceId = data.spaceId;
    } catch (e) {
      console.error('[RegisterPage] Failed to parse pending data:', e);
    }
  }

  useEffect(() => {
    const validType = userType === 'provider' || userType === 'seeker' ? userType : 'seeker';
    
    console.log('[RegisterPage] Opening registration modal with:', {
      userType: validType,
      isBookingFlow,
      spaceId,
      hasPendingBookingAfterOAuth,
      justRegisteredForBooking,
      pendingData: !!pendingData
    });
    
    openModal({
      content: (
        <SignupForm 
          type={validType}
          forBookingForm={isBookingFlow}
          spaceId={spaceId}
          onSuccess={() => {
            console.log('[RegisterPage] Registration success callback');
          }}
        />
      ),
      title: validType === 'provider' ? t("modal.register.titleProvider") : t("modal.register.titleSeeker"),
      onClose: () => {
        closeModal();
        
        // ============================================================
        // FIX: Clean up abandoned registration flags
        // ============================================================
        // If the user closes the registration modal WITHOUT completing
        // registration, we must clear the "pending booking" flags that
        // AuthEndpoint set optimistically before redirecting to /register.
        //
        // Detection: if no auth token exists, the user is NOT
        // authenticated → registration was abandoned.
        // ============================================================
 const hasToken = !!getToken();

        
        if (!hasToken) {
          console.log('[RegisterPage] Registration abandoned - cleaning up OAuth flags');
          sessionStorage.removeItem('has_pending_booking_after_oauth');
          sessionStorage.removeItem('just_logged_in_for_booking');
          sessionStorage.removeItem('just_registered_for_booking');
          sessionStorage.removeItem('pending_booking_data');
          sessionStorage.removeItem('booking_space_id');
          sessionStorage.removeItem('google_registration_data');
          sessionStorage.removeItem('google_oauth_intent');
          sessionStorage.removeItem('google_signup_type');
          sessionStorage.removeItem('google_oauth_state');
          sessionStorage.removeItem('signup_booking_context');
        }
        
        if (isBookingFlow && spaceId) {
          navigate(`/space/${spaceId}`);
        } 
        // else {
        //   const previousUrl = document.referrer || window.history.state?.url;
          
        //   if (previousUrl && previousUrl.includes('/auth/auth-endpoint')) {
        //     navigate('/');
        //   } else {
        //     navigate(-1);
        //   }
        // }
      }
    });

    return () => {
      closeModal();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType, isBookingFlow, spaceId]);

  return <HomePage />;
};

RegisterPage.propTypes = {
  userType: PropTypes.oneOf(['provider', 'seeker'])
};

export default RegisterPage;